import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { RegionSelectionOptions } from '../components/RegionSelectionOptions';

export const RegionSelectionOptionsProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <RegionSelectionOptions {...data} />
        </Provider>
    );
};

RegionSelectionOptionsProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
